import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { dayLabel } from "@/lib/dates";
import { fmtDateTime } from "@/lib/constants";

const STATUS = {
  accepted: ["Swapped", "bg-emerald-500/20 text-emerald-300"],
  open: ["Up for swap", "bg-violet-500/25 text-violet-200"],
  withdrawn: ["Withdrawn", "bg-zinc-500/25 text-zinc-300"],
  cancelled: ["Cancelled", "bg-red-500/20 text-red-300"],
};

const Row = ({ o, color }) => {
  const [label, cls] = STATUS[o.status] || [o.status, "bg-secondary"];
  return (
    <div data-testid={`swap-history-${o.id}`} className="flex flex-wrap items-center justify-between gap-2 border-b px-5 py-3 last:border-0" style={{ borderLeft: `4px solid ${color || "#FEDC19"}` }}>
      <div className="min-w-0 text-sm">
        <div className="font-semibold">{o.from_user_name} → {o.accepted_by_name || o.to_user_name || "anyone"}</div>
        <div className="text-xs text-muted-foreground">{o.area_name} · {dayLabel(o.date)} · {o.template_name} {o.start}–{o.end} · {o.position_label}{o.closed_reason ? ` · ${o.closed_reason}` : ""}</div>
      </div>
      <div className="flex w-full items-center gap-2 sm:block sm:w-auto sm:text-right">
        <span className={`rounded-full px-2 py-0.5 text-[11px] font-bold ${cls}`}>{label}</span>
        <div className="mt-1 font-mono text-[10px] text-muted-foreground">{fmtDateTime(o.closed_at || o.created_at)}</div>
      </div>
    </div>
  );
};

export const SwapHistory = () => {
  const [areas, setAreas] = useState([]);
  const [areaId, setAreaId] = useState("");
  const [days, setDays] = useState(30);
  const [items, setItems] = useState(null);
  useEffect(() => { api.get("/rota/setup").then((r) => setAreas(r.data.areas)); }, []);
  useEffect(() => {
    api.get("/rota/swap-history", { params: { days, area_id: areaId || undefined } }).then((r) => setItems(r.data));
  }, [areaId, days]);
  const chip = (active, color) => (active ? { background: color, borderColor: color, color: "#fff" } : { borderColor: color });
  return (
    <section className="space-y-3" data-testid="control-swaps">
      <div className="flex flex-wrap items-center gap-2">
        <button onClick={() => setAreaId("")} data-testid="swap-area-all" style={chip(!areaId, "#FEDC19")} className={`rounded-full border-2 px-4 py-1.5 text-sm font-semibold ${!areaId ? "!text-black" : "text-muted-foreground"}`}>All areas</button>
        {areas.filter((a) => a.active).map((a) => <button key={a.id} onClick={() => setAreaId(a.id)} data-testid={`swap-area-${a.id}`} style={chip(areaId === a.id, a.color)} className="rounded-full border-2 px-4 py-1.5 text-sm font-semibold text-muted-foreground">{a.name}</button>)}
        <select value={days} onChange={(e) => setDays(Number(e.target.value))} data-testid="swap-days-select" className="h-9 rounded-full border bg-background px-3 text-sm">
          {[7, 30, 90, 365].map((d) => <option key={d} value={d}>Last {d} days</option>)}
        </select>
      </div>
      <div className="overflow-hidden rounded-2xl border bg-card">
        {items === null && <div className="h-24 animate-pulse" />}
        {items?.length === 0 && <p className="px-5 py-8 text-sm text-muted-foreground" data-testid="swap-history-empty">No shift swaps in this period.</p>}
        {items?.map((o) => <Row key={o.id} o={o} color={areas.find((a) => a.id === o.area_id)?.color} />)}
      </div>
    </section>
  );
};
